import modalService from '@/service/modal.service'

import { SCHEDULE_LIST_STRINGS } from '../_constants/scheduleStrings'

const preLine = { whiteSpace: 'pre-line' as const, textAlign: 'center' as const }

// ESC·딤 클릭으로 닫히면 resolve 가 불리지 않아 Promise 가 영원히 남으므로 버튼으로만 닫게 한다
const buttonsOnly = { hasCloseButton: false, isCloseable: false }

/** 주의 얼럿을 Promise 로 감싼다. 확인 true, 취소 false. 두 경우 모두 얼럿을 닫는다 */
export const confirmWarning = (message: string, actionButtonText = '확인') =>
  new Promise<boolean>((resolve) => {
    modalService.openWarningModal(
      {
        content: <p css={preLine}>{message}</p>,
        actionButtonText,
        onClick: () => {
          modalService.closeModal()
          resolve(true)
        },
        onCancelClick: () => {
          modalService.closeModal()
          resolve(false)
        },
      },
      buttonsOnly,
    )
  })

/** 일반 확인 모달. 확인·취소 어느 쪽이든 닫기만 한다(5분 잠김 안내처럼 진행을 막을 때) */
export const showNotice = (message: string) =>
  new Promise<void>((resolve) => {
    modalService.openConfirmModal(
      {
        content: <p css={preLine}>{message}</p>,
        onClick: () => {
          modalService.closeModal()
          resolve()
        },
        onCancel: () => {
          modalService.closeModal()
          resolve()
        },
      },
      buttonsOnly,
    )
  })

export const confirmCancelSchedule = () => confirmWarning(SCHEDULE_LIST_STRINGS.cancelConfirm())
